import React from 'react';
import CustomTabHeader from './CustomTabHeader';

type Props = {
  selectedTabId: string;
  onChange: (newTabId: string) => void;
  tabItems: ICustomTab[];
  fitContent?: boolean;
};

export const CustomTabs = ({
  selectedTabId,
  onChange,
  tabItems,
  fitContent = false
}: Props) => {
  const hasMultipleTabs = tabItems.filter((tab) => !tab.isHidden).length > 1;
  const fitContentClass = `${fitContent ? '' : 'full-width'}`;
  const multipleTabsClass = `${hasMultipleTabs ? 'with-tabs' : 'no-tabs'}`;
  return (
    <div
      className={`custom-tabs-header ${fitContentClass} ${multipleTabsClass}`}
    >
      {hasMultipleTabs &&
        tabItems.map(
          (tab) =>
            !tab.isHidden && (
              <CustomTabHeader
                id={tab.id}
                key={tab.id}
                label={tab.label}
                onClick={(e, newKey) => onChange(newKey)}
                isSelected={selectedTabId === tab.id}
                title={tab.title}
                isDisabled={tab.isDisabled}
                postfixIconClass={tab.postfixIconClass}
              />
            )
        )}
    </div>
  );
};

export interface ICustomTab {
  id: string;
  label: string;
  title?: string;
  isDisabled?: boolean;
  isHidden?: boolean;
  postfixIconClass?: string;
}
